import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M15.829 3.879 12.12.17A.6.6 0 0 0 11.707 0H.585A.585.585 0 0 0 0 .585v14.83c0 .323.262.585.585.585h14.83a.585.585 0 0 0 .585-.585V4.293a.59.59 0 0 0-.171-.414M4.879 1.17h6.243v3.463H4.878zm7.635 13.658H3.486V9.904h9.028zm2.315 0h-1.144V9.32a.585.585 0 0 0-.586-.586H2.901a.585.585 0 0 0-.586.586v5.51H1.171V1.171h2.536v4.048c0 .324.262.586.586.586h7.414a.585.585 0 0 0 .586-.586V2l2.536 2.536z\"></path><path d=\"M9.672 1.719a.585.585 0 0 0-.585.585V3.5a.585.585 0 1 0 1.17 0V2.304a.585.585 0 0 0-.585-.585\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }